import { render, staticRenderFns } from "./customer-office-show.vue?vue&type=template&id=13d1d44a&scoped=true&"
import script from "./customer-office-show.vue?vue&type=script&lang=js&"
export * from "./customer-office-show.vue?vue&type=script&lang=js&"
import style0 from "./customer-office-show.vue?vue&type=style&index=0&id=13d1d44a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1d44a",
  null
  
)

export default component.exports